// extracted by mini-css-extract-plugin
export var cardHeader = "_rx-0";
export var reorderHandle = "_rx-3";
export var titleArea = "_rx-1";
export var titleAreaWithHandle = "_rx-2";